var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLaptopAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00027 3.75C5.30991 3.75 4.75027 4.30964 4.75027 5V13.75H19.2503V12.5C19.2503 12.0858 19.5861 11.75 20.0003 11.75C20.4145 11.75 20.7503 12.0858 20.7503 12.5V14.3675L22.5712 19.3622C22.9194 20.2036 22.7352 21.0727 22.2369 21.7091C21.7395 22.3445 20.9349 22.75 20.0214 22.75H3.97916C3.06562 22.75 2.26101 22.3445 1.76359 21.7091C1.26531 21.0727 1.08115 20.2036 1.42928 19.3622L3.25027 14.3675V5C3.25027 3.48122 4.48149 2.25 6.00027 2.25H11.0003C11.4145 2.25 11.7503 2.58579 11.7503 3C11.7503 3.41421 11.4145 3.75 11.0003 3.75H6.00027ZM4.52512 15.25L2.826 19.9104L2.81852 19.9281C2.69282 20.2248 2.74507 20.5295 2.94467 20.7844C3.14892 21.0453 3.51227 21.25 3.97916 21.25H20.0214C20.4882 21.25 20.8516 21.0453 21.0558 20.7844C21.2554 20.5295 21.3077 20.2248 21.182 19.9281L21.1745 19.9104L19.4754 15.25H4.52512Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 1.25C18.4142 1.25 18.75 1.58579 18.75 2V5.25H22C22.4142 5.25 22.75 5.58579 22.75 6C22.75 6.41421 22.4142 6.75 22 6.75H18.75V10C18.75 10.4142 18.4142 10.75 18 10.75C17.5858 10.75 17.25 10.4142 17.25 10V6.75H14C13.5858 6.75 13.25 6.41421 13.25 6C13.25 5.58579 13.5858 5.25 14 5.25H17.25V2C17.25 1.58579 17.5858 1.25 18 1.25Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLaptopAdd);
export default __webpack_public_path__ + "static/media/ic-laptop-add.db405b54a8a825b06ef6c24793cb8a65.svg";
export { ForwardRef as ReactComponent };